var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.96967 9.03033C0.676777 8.73744 0.676777 8.26256 0.96967 7.96967C1.26256 7.67678 1.73744 7.67678 2.03033 7.96967L7 12.9393V0.75C7 0.335786 7.33579 0 7.75 0C8.16421 0 8.5 0.335786 8.5 0.75V12.9393L13.4697 7.96967C13.7626 7.67678 14.2374 7.67678 14.5303 7.96967C14.8232 8.26256 14.8232 8.73744 14.5303 9.03033L8.28033 15.2803C7.98744 15.5732 7.51256 15.5732 7.21967 15.2803L0.96967 9.03033Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18.5C0.335786 18.5 0 18.8358 0 19.25C0 19.6642 0.335786 20 0.75 20H15.25C15.6642 20 16 19.6642 16 19.25C16 18.8358 15.6642 18.5 15.25 18.5H0.75Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadArrow);
export default __webpack_public_path__ + "static/media/icon_upload_arrow.9ae8468d4df21e0e908581b4f2be2f54.svg";
export { ForwardRef as ReactComponent };